import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button } from "react-bootstrap";

import SearchTable from "../../../components/GeneralComponents/SearchTable/SearchTable";
import styles from "./generalSectionComponent.module.css";
import useChapterActionIdMatch from "../../../hooks/useChapterActionIdMatch";
import { useNavigate } from "react-router-dom";

function GeneralSectionComponent({
  title,
  dataFromStateSelector,
  getActionAll,
  getAction,
  headerColumns,
  ModalComponent,
  searchTableSize,
  externalStyles = false,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isSelected, setIsSelected] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [dataTypeValue, setDataTypeValue] = useState("");
  const [idItem, setIdItem] = useState();

  const dataFromState = useSelector(dataFromStateSelector);

  const url = window.location.href;

  const handleStatementId = (value) => {
    setIsSelected(true);
    setIdItem(value);
    dispatch(getAction(value));
  };

  const isShowEditButton = () => {
    if (!dataFromState) return;

    if (url.includes("/maintainingDirectories/settlements")) {
      const filteredObjects = dataFromState.find((item) => item.id === Number(idItem));
      return !filteredObjects?.dateout;
    } else if (url.includes("/maintainingDirectories/gimsSections")) {
      const filteredObjects = dataFromState.find((item) => item.id === Number(idItem));
      return !filteredObjects?.dateEnd;
    } else if (url.includes("maintainingDirectories/administrativeDistricts")) {
      const filteredObjects = dataFromState.find((item) => item.id === Number(idItem));
      return !filteredObjects?.dateEnd;
    } else {
      return true;
    }
  };

  const comeBack = () => {
    navigate("/maintainingDirectories");
  };

  const handleSaveModal = () => {
    setShowModal(false);
  };

  const openModal = (e, type) => {
    setDataTypeValue(type);
    setShowModal(!showModal);
  };

  useEffect(() => {
    setIsSelected(false);
  }, [dataFromState]);

  useEffect(() => {
    if (getActionAll) {
      dispatch(getActionAll());
    }
  }, [dispatch]);

  return (
    <div className={styles["content-container"]}>
      <h2 className={styles["main-text"]}>{title}</h2>
      <SearchTable
        setId={handleStatementId}
        dataFromState={dataFromState}
        headerColumns={headerColumns}
        searchTableSize={searchTableSize}
        externalStyles={externalStyles}
      />
      <div className={styles["buttons-block"]}>
        <div className={styles["buttons-with-actions"]}>
          {!headerColumns[0].onlyEdit && (
            <button
              className={styles["add-btn"]}
              onClick={(e) => openModal(e, "add")}>
              Добавить запись
            </button>
          )}
          {!headerColumns[0].onlySave && isShowEditButton() && (
            <button
              disabled={!isSelected}
              className={styles["other-btn"]}
              onClick={(e) => openModal(e, "edit")}>
              Редактировать
            </button>
          )}
        </div>
        <button
          className={styles["close-btn"]}
          onClick={comeBack}>
          Назад
        </button>
      </div>
      {showModal && (
        <ModalComponent
          setShow={setShowModal}
          show={showModal}
          type={dataTypeValue}
          setSave={handleSaveModal}
        />
      )}
    </div>
  );
}

export default GeneralSectionComponent;
